import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

import Alert from '../../../components/alert/Alert';
import translation from '../../../translation/translation';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 450
    }
  },
  statusKYC: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  label: {
    fontWeight: 600
  },
  value: {
    fontWeight: 400,
    overflow: 'auto',
    wordWrap: 'break-word'
  },
  item: {
    display: 'flex',
    width: '100%',
    gap: 4,
    alignItems: 'center'
  },
  validValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontWeight: 700
  },
  validIcon: {
    color: '#2e7d32'
  },
  invalidIcon: {
    color: '#d32f2f'
  },
  dataBox: {
    marginTop: 8,
    padding: '10px 12px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    fontSize: 12,
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    maxHeight: 320,
    overflow: 'auto',
    color: '#333'
  }
}));

function StatusKYC(props) {
  const { getStatusKYC, resource } = props;
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [statusKYC, setStatusKYC] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (resource && resource.user && resource.user.id) {
      setError(null);
      setLoading(true);

      getStatusKYC(
        resource.user.id,
        (success) => {
          setLoading(false);

          if (success) {
            setStatusKYC(success);
          }
        },
        (error) => {
          setLoading(false);
          setStatusKYC(null);
          setError(
            typeof error === 'string'
              ? error
              : translation().core.list.dialogs.custom_list_actions.status_kyc.callbacks.error
          );
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="StatusKYC">
      <div className={classes.root}>
        {statusKYC && (
          <div className={classes.statusKYC}>
            <div className={classes.item}>
              <Typography className={classes.label}>Valid:</Typography>
              <span className={classes.validValue}>
                {statusKYC.valid ? <CheckCircleIcon className={classes.validIcon} fontSize="small" /> : <CancelIcon className={classes.invalidIcon} fontSize="small" />}
              </span>
            </div>
            <div className={classes.dataBox}>
              {JSON.stringify(statusKYC, null, 2)}
            </div>
          </div>
        )}
        {error && (
          <Alert
            type="danger"
            style={{ marginTop: 10 }}
            status={translation().commons.alerts.error}
            text={error}
          />
        )}
        {isLoading && (
          <div className="loader-wpr">
            <CircularProgress color="primary" size={25} />
            <p>
              {translation().core.list.dialogs.custom_list_actions.status_kyc.loading}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

StatusKYC.propTypes = {
  getStatusKYC: PropTypes.func.isRequired,
  resource: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  })
};

export default StatusKYC;
